import { Article } from '../types/Header';
import { cache } from 'react';

export const fetchArticles = cache(async (
  page?: number,
  searchQuery?: string,
  lang?: string,
  url?: string
): Promise<Article[]> => {
  try {
    const fetchAllArticles = !page && !searchQuery;
    const response = fetchAllArticles
      ? await fetch(`${url ?? ''}/api/articles?lang=${lang}`)
      : await fetch(
        `${url ?? ''}/api/articles?page=${page}&query=${encodeURIComponent(searchQuery ?? '')}&lang=${lang}`
      );

    if (!response.ok) {
      throw new Error('Failed to fetch articles');
    }
    return await response.json();
  } catch (error) {
    console.error(error);
    return [];
  }
})
